<script type="text/javascript">
    import MultiFileInput from '@/components/Form/MultiFileInput/MultiFileInput.vue';
    
    export default {
        MultiFileInput,
    }
</script>